import React from 'react';
import { Headline, Paragraph } from '@cambridgeassessment/cambridge-ui';
import { Roles } from '@cambridgeassessment/lib-ee-commons';
import { Authorized } from 'lib-browser';
import { StyledContainer } from '../Content.styles';
import Selector from './components/Selector';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';

const DownloadWorkPage: React.FC = () => {
  const selectedRole = useSelector((state: RootState) => state.userData.selectedRole);

  return (
    <Authorized
      selectedRole={selectedRole}
      roles={[
        Roles.SUBMIT_SUPER_ADMIN,
        Roles.SUBMIT_ADMINISTRATOR,
        Roles.SUBMIT_COMPLIANCE,
        Roles.SUBMIT_INTERNAL_ASSESSMENT_MANAGER,
      ]}
    >
      <StyledContainer data-qa-id='page-priming-work-downloading'>
        <Headline data-qa-id='work-downloading-headline'>View and download candidate work</Headline>
        <Paragraph data-qa-id='work-downloading-paragraph'>
          Search for, view and download submitted candidate work.
        </Paragraph>
        <Selector />
      </StyledContainer>
    </Authorized>
  );
};

export default DownloadWorkPage;
